var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1395 5.86047C26.3256 -1.95349 13.6744 -1.95349 5.86047 5.86047C-1.95349 13.6744 -1.95349 26.3256 5.86047 34.1395C13.6744 41.9535 26.3256 41.9535 34.1395 34.1395C41.9535 26.3256 41.9535 13.5814 34.1395 5.86047ZM7.90698 32.093C1.2093 25.3953 1.2093 14.4186 7.90698 7.72093C14.6047 1.02326 25.5814 1.02326 32.2791 7.72093C38.9767 14.4186 38.9767 25.3953 32.2791 32.093C25.4884 38.8837 14.6047 38.8837 7.90698 32.093Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0931 21.5817C20.9665 21.5817 21.6745 20.8737 21.6745 20.0003C21.6745 19.127 20.9665 18.4189 20.0931 18.4189C19.2197 18.4189 18.5117 19.127 18.5117 20.0003C18.5117 20.8737 19.2197 21.5817 20.0931 21.5817Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.861 15.8141C21.861 16.5583 21.2098 17.2094 20.4657 17.2094C19.7215 17.2094 19.0703 16.5583 19.0703 15.8141V11.1629C19.0703 10.4187 19.7215 9.76758 20.4657 9.76758C21.2098 9.76758 21.861 10.4187 21.861 11.1629V15.8141Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9514 21.86C22.5095 21.3019 23.3467 21.3019 23.9049 21.86L30.2304 28.1856C30.7886 28.7437 30.7886 29.5809 30.2304 30.1391C29.6723 30.6972 28.8351 30.6972 28.277 30.1391L21.9514 23.8135C21.4863 23.3484 21.4863 22.4182 21.9514 21.86Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d4fccbdec6d161aae757db31be2307b0.svg";
export { ForwardRef as ReactComponent };